import axios from 'axios';
import { BASE_URL, requestForm } from '../../Common/api/client';

/** 상대 경로를 풀 URL로 변환 */
function toFullUrl(baseUrl, path) {
  if (!path) return '';
  const base = (baseUrl || '').replace(/\/$/, '');
  return path.startsWith('http') ? path : `${base}${path.startsWith('/') ? path : '/' + path}`;
}

/**
 * 사이트 이미지 조회 (공개, 로그인 화면 등에서 사용, 인증 불필요)
 * GET /api/public/site-assets
 * @returns {Promise<{ logoUrl: string, backgroundUrl: string }>}
 */
export async function getPublicSiteAssets() {
  const url = `${BASE_URL}/api/public/site-assets`;
  try {
    const res = await axios({
      method: 'GET',
      url,
      withCredentials: true,
      headers: { 'Content-Type': 'application/json' },
    });
    const body = res.data ?? {};
    if (body.code !== 1000) return { logoUrl: '', backgroundUrl: '' };
    return {
      logoUrl: toFullUrl(BASE_URL, body.SITE_LOGO_URL),
      backgroundUrl: toFullUrl(BASE_URL, body.LOGIN_BACKGROUND_URL),
    };
  } catch (e) {
    return { logoUrl: '', backgroundUrl: '' };
  }
}

/**
 * 사이트 이미지 조회 (관리자 전용, 인증 필요)
 * GET /api/admin/site-assets
 * 응답: { SITE_LOGIN_LOGO_URL, SITE_LOGIN_BACKGROUND_URL, SITE_HEADER_LOGO_URL }
 * ※ 화면 표시는 고정 경로 사용. 조회는 필요 시에만 호출.
 */
export async function getSiteAssets() {
  const url = `${BASE_URL}/api/admin/site-assets`;
  const res = await axios({
    method: 'GET',
    url,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
  });
  const body = res.data ?? {};
  if (body.code != null && body.code !== 1000) {
    throw new Error(body.msg || '사이트 이미지 조회에 실패했습니다.');
  }
  return {
    SITE_LOGIN_LOGO_URL: body.SITE_LOGIN_LOGO_URL,
    SITE_LOGIN_BACKGROUND_URL: body.SITE_LOGIN_BACKGROUND_URL,
    SITE_HEADER_LOGO_URL: body.SITE_HEADER_LOGO_URL,
  };
}

/**
 * 사이트 이미지 단일 업로드
 * POST /api/admin/site-assets/upload
 * FormData: type = 'login_logo' | 'login_background' | 'header_logo', file = 이미지 파일
 * @param {'login_logo'|'login_background'|'header_logo'} type
 * @param {File} file
 */
export async function uploadSiteAsset(type, file) {
  const form = new FormData();
  form.append('type', type);
  form.append('file', file);
  return requestForm({ method: 'POST', url: '/api/admin/site-assets/upload', data: form });
}

/**
 * 사이트 이미지 멀티 업로드
 * POST /api/admin/site-assets/upload-multi
 * FormData: login_logo (파일), login_background (파일), header_logo (파일) — 있는 것만 append
 * @param {{ login_logo?: File, login_background?: File, header_logo?: File }} files
 */
export async function uploadSiteAssetsMulti(files) {
  const form = new FormData();
  if (files.login_logo) form.append('login_logo', files.login_logo);
  if (files.login_background) form.append('login_background', files.login_background);
  if (files.header_logo) form.append('header_logo', files.header_logo);
  return requestForm({ method: 'POST', url: '/api/admin/site-assets/upload-multi', data: form });
}
